import { useSmartProp } from '@smartfire/js-block-engine';
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';

const Inspector = () => {
    const [defaultText, setDefaultText] = useSmartProp('defaultText');
    const [hoverText, setHoverText] = useSmartProp('hoverText');
    const [defaultEmoji, setDefaultEmoji] = useSmartProp('defaultEmoji');
    const [hoverEmoji, setHoverEmoji] = useSmartProp('hoverEmoji');

    return (
        <PanelBody title="Paramètres" initialOpen>
            <PanelRow>
                <TextControl label="Texte par défaut" value={defaultText} onChange={setDefaultText} />
            </PanelRow>
            <PanelRow>
                <TextControl label="Texte au survol" value={hoverText} onChange={setHoverText} />
            </PanelRow>
            <PanelRow>
                <TextControl label="Émoji par défaut" value={defaultEmoji} onChange={setDefaultEmoji} />
            </PanelRow>
            <PanelRow>
                <TextControl label="Émoji au survol" value={hoverEmoji} onChange={setHoverEmoji} />
            </PanelRow>
        </PanelBody>
    );
};

export default Inspector;
